import { NavLink, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import {
  IoCubeOutline,
  IoCarOutline,
  IoFlashOutline,
  IoLocateOutline,
  IoLayersOutline,
  IoSyncOutline,
  IoSettingsOutline,
  IoLogOutOutline,
} from 'react-icons/io5';
import { AuthProvider, useAuth } from './auth';
import { ProductsPage } from './pages/ProductsPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { StrategiesPage } from './pages/StrategiesPage';
import { StrategyEditPage } from './pages/StrategyEditPage';
import { StrategyProductsPage } from './pages/StrategyProductsPage';
import { OzonStrategiesPage } from './pages/OzonStrategiesPage';
import { RepricersPage } from './pages/RepricersPage';
import { ShipmentsPage } from './pages/ShipmentsPage';
import { ShipmentDetailPage } from './pages/ShipmentDetailPage';
import { SyncPage } from './pages/SyncPage';
import { SettingsPage } from './pages/SettingsPage';
import { LoginPage } from './pages/LoginPage';

export function App() {
  return (
    <AuthProvider>
      <AppShell />
    </AuthProvider>
  );
}

function AppShell() {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) return <div style={{ padding: 32 }}>Загрузка…</div>;

  if (!user) {
    if (loc.pathname !== '/login') return <Navigate to="/login" replace />;
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  if (loc.pathname === '/login') return <Navigate to="/products" replace />;

  return (
    <div className="app-shell">
      <Sidebar />
      <main className="content">
        <Routes>
          <Route path="/" element={<Navigate to="/products" replace />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:productId" element={<ProductDetailPage />} />
          <Route path="/strategies" element={<StrategiesPage />} />
          <Route path="/strategies/new" element={<StrategyEditPage />} />
          <Route path="/strategies/:id" element={<StrategyEditPage />} />
          <Route path="/strategies/:id/products" element={<StrategyProductsPage />} />
          <Route path="/ozon-strategies" element={<OzonStrategiesPage />} />
          <Route path="/repricers" element={<RepricersPage />} />
          <Route path="/shipments" element={<ShipmentsPage />} />
          <Route path="/shipments/:postingNumber" element={<ShipmentDetailPage />} />
          <Route path="/sync" element={<SyncPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Routes>
      </main>
    </div>
  );
}

function Sidebar() {
  const { user, logout } = useAuth();
  return (
    <aside className="sidebar">
      <h1>Ozon Repricer</h1>
      <nav>
        <NavLink to="/products" className={({ isActive }) => (isActive ? 'active' : '')}>
          <span className="icon"><IoCubeOutline /></span> Товары
        </NavLink>
        <NavLink to="/shipments" className={({ isActive }) => (isActive ? 'active' : '')}>
          <span className="icon"><IoCarOutline /></span> Отгрузки
        </NavLink>
        <NavLink to="/repricers" className={({ isActive }) => (isActive ? 'active' : '')}>
          <span className="icon"><IoFlashOutline /></span> Репрайсеры
        </NavLink>
        <NavLink to="/strategies" className={({ isActive }) => (isActive ? 'active' : '')}>
          <span className="icon"><IoLocateOutline /></span> Стратегии (наши)
        </NavLink>
        <NavLink to="/ozon-strategies" className={({ isActive }) => (isActive ? 'active' : '')}>
          <span className="icon"><IoLayersOutline /></span> Стратегии Ozon
        </NavLink>
        <NavLink to="/sync" className={({ isActive }) => (isActive ? 'active' : '')}>
          <span className="icon"><IoSyncOutline /></span> Синхронизация
        </NavLink>
        <NavLink to="/settings" className={({ isActive }) => (isActive ? 'active' : '')}>
          <span className="icon"><IoSettingsOutline /></span> Настройки
        </NavLink>
      </nav>
      <div className="sidebar-footer">
        <div style={{ color: '#cbd5e1', marginBottom: 10 }}>
          <div style={{ fontWeight: 500, fontSize: 13 }}>{user?.email}</div>
          <div style={{ fontSize: 11, color: '#8a8f99' }}>
            {user?.role === 'admin' ? 'администратор' : 'просмотр'}
          </div>
        </div>
        <button
          onClick={() => logout()}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.12)',
            color: '#cbd5e1', padding: '7px 12px', borderRadius: 6, cursor: 'pointer',
            width: '100%', fontSize: 12, justifyContent: 'center', fontFamily: 'inherit',
          }}
        >
          <IoLogOutOutline /> Выйти
        </button>
      </div>
    </aside>
  );
}
